export default {
  titles: {
    location: 'Standort',
    date_time: 'Datum & Uhrzeit',
  },
};
